module.exports = __webpack_public_path__ + "images/FlowBuilder-47454dce16db5aff8c12115f81595af0.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/screenshots/FlowBuilder.png
// module id = uKCT
// module chunks = 0